import { __ } from '@wordpress/i18n';
import { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from '@wordpress/components';
import { useDispatch, useSelect } from '@wordpress/data';
import { CloseIcon, PluginIcon } from './icons.js';
import Preview from './preview.js';

/**
 * Editor css.
 */
import './editor.scss';

export default function Edit(props) {
	const { attributes } = props;
	const { pluginPath, pluginName, pluginPage, logo, description, preview, pluginInstalled } = attributes;

	const { removeBlock } = useDispatch('core/block-editor');

	const wasJustInserted = useSelect(
		(select) => {
			const editor = select('core/block-editor');
			return editor && editor.wasBlockJustInserted
				? editor.wasBlockJustInserted(props.clientId)
				: false;
		},
		[]
	);

	const [show, setShow] = useState(false);
	const [installing, setInstalling] = useState(false);
	const [installed, setInstalled] = useState(false);
	const handleClose = () => {
		removeBlock(props.clientId);
		setShow(false);
	};
	const goToPluginPage = () => {
		removeBlock(props.clientId);
		setShow(false);
		window.location.href = pluginPage;
	}

	const installPlugin = () => {
		const nonce = recommendedBlocksData.nonce;
		const actionUrl = recommendedBlocksData.siteUrl;

		const data = {
			'action': 'am_recommended_block_install',
			'nonce': nonce,
			'plugin': pluginPath,
		}

		const url = new URL(actionUrl);
		url.search = new URLSearchParams(data).toString();

		setInstalling(true);

		fetch(url, {
			cache: 'no-cache',
			headers: {
				'user-agent': 'Recommended Block',
				'content-type': 'application/json'
			},
			method: 'POST',
		})
			.then(response => response.json())
			.then(data => {
				setInstalling(false);
				if (data.success) {
					setInstalled(true);
				}
			})
			.catch(() => {
				setInstalling(false);
			})
	};

	useEffect(() => {
		if (wasJustInserted) {
			setShow(true);
		}
	}, []);

	if (preview) {
		return (
			<Preview pluginName={pluginName} />
		);
	}

	if (!show) {
		return null;
	}

	return (
		<Modal
			__experimentalHideHeader={true}
			onRequestClose={handleClose}
			className='am-recommended-block-modal'
		>
			<div className="am-modal-header">
				<div className="am-modal-title-wrap">
					<span className='am-modal-icon'>
						{logo || <PluginIcon />}
					</span>
					<div className="am-modal-title">
						<div className='am-requires'>
							{__('REQUIRES', 'smashballoon')}
						</div>
						<div className="am-title">
							<h2>
								{pluginName}
							</h2>
							<span className="am-plugin-tag">
								{__('FREE', 'smashballoon')}
							</span>
						</div>
					</div>
				</div>
			</div>

			<div className="am-modal-content-wrap">
				<div className="am-modal-content">
					<p dangerouslySetInnerHTML={{ __html: description }} />
					<Button
						className='am-modal-cta-btn'
						onClick={installed ? goToPluginPage : installPlugin}
						variant="primary"
						disabled={installing}
						isBusy={installing}
					>
						{installing
							? (pluginInstalled
								? __('Activating…', 'smashballoon')
								: __('Installing…', 'smashballoon'))
							: installed
								? __("Installed! Go to Plugin's Page.", 'smashballoon')
								: pluginInstalled
									? __('Activate', 'smashballoon')
									: __('Install', 'smashballoon')}
						{installing && <Spinner />}
					</Button>
				</div>
			</div>

			<Button
				icon={CloseIcon}
				onClick={handleClose}
				className='am-modal-close'
			/>
		</Modal>
	);
}
